/**
 * API 统一业务与 HTTP 异常类
 */
export class ApiError extends Error {
  readonly code: string | number
  readonly status: number

  constructor(code: string | number, message: string, status: number) {
    super(message)
    this.name = 'ApiError'
    this.code = code
    this.status = status
  }
}
